import { QueryClient } from '@tanstack/react-query';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Stale time: How long data is considered fresh (5 seconds)
      staleTime: 5 * 1000,
      
      // Cache time: How long data stays in cache when not used (5 minutes)
      gcTime: 5 * 60 * 1000,
      
      // Refetch on window focus (when user switches back to tab)
      refetchOnWindowFocus: true,
      
      // NOTE: refetchIntervalInBackground removed - using manual visibility control instead
      
      // Retry failed requests with exponential backoff
      retry: 3,
      retryDelay: (attemptIndex: number) => Math.min(1000 * 2 ** attemptIndex, 30000),
      
      // Show stale data while refetching
      refetchOnMount: 'always',
    },
    mutations: {
      // Retry mutations once
      retry: 1,
    },
  },
});

// Query key factory for consistent key generation
export const queryKeys = {
  // Pipeline status queries
  pipelineStatus: (dagId: string, runId: string) => ['pipeline-status', dagId, runId] as const,
  completePipelineStatus: (date: string) => ['complete-pipeline-status', date] as const,
  
  // Insights queries
  insights: (userId: string, date: string) => ['insights', userId, date] as const,
  
  // Airflow health and status
  airflowHealth: () => ['airflow-health'] as const,
  runningPipeline: (date: string) => ['running-pipeline', date] as const,
  recentPipeline: (date: string) => ['recent-pipeline', date] as const,
  
  // Prompts
  prompts: () => ['prompts'] as const,
  prompt: (name: string) => ['prompt', name] as const,
  promptDocs: (name: string) => ['prompt-docs', name] as const,
  promptVersions: (name: string) => ['prompt-versions', name] as const,

  // Inventory data
  inventoryDates: () => ['inventory', 'dates'] as const,
  inventoryUsers: (date: string) => ['inventory', 'users', date] as const,
} as const;
